import { render, staticRenderFns } from "./app-bar-notification.vue?vue&type=template&id=d24513fa&scoped=true&lang=pug&"
import script from "./app-bar-notification.vue?vue&type=script&lang=ts&"
export * from "./app-bar-notification.vue?vue&type=script&lang=ts&"
import style0 from "./app-bar-notification.vue?vue&type=style&index=0&id=d24513fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24513fa",
  null
  
)

export default component.exports